import { BaseResponse } from "../base-response";

export class PairingResponse extends BaseResponse {
  public Secret: string;
}
